import React from 'react';
import { Helmet } from 'react-helmet';
import usePageBackground from '../hooks/usePageBackground';
import { Box } from '@mui/material';
import FormFill from './formFill.jsx';
import { useEffect, useState } from 'react';
import { getAllForms } from '../assets/js/endpoints';
import Loader from '../components/loader';
import { useFadeInOnScroll } from '../theme/global';
import '../css/global.css';


export default function JoinUs({formularios}) {
   const [loading, setLoading] = useState(true);
  usePageBackground('form-background-color');
  const joinRef = useFadeInOnScroll([loading]);
  const [contactForms, setContactForms] = useState([]);
 

  useEffect(() => {

    const fetchFormsIfNeeded = async () => {
      const forms =
        !formularios || formularios.length === 0
          ? await getAllForms()
          : formularios;

      const filtered = forms.filter(f =>
        ['Contacto', 'Sugerencias'].includes(f.form_type?.name)
      );

      setContactForms(filtered);
      setLoading(false);
    };

    fetchFormsIfNeeded();

  }, [formularios]);


  if (loading) {
    return <Loader />;
  }

  return (
    <>
    <Helmet>
      <title>Únete | CES</title>
      <meta name="description" content="Envía tus datos para unirte a CES." />
    </Helmet>
    <Box ref={joinRef} className="fade-up" sx={{ display: 'flex', flexDirection: 'column', gap: 6, p: 2, m: 2 }}>
      {contactForms.map(f => (
        <FormFill key={f.id} formularios={f} />
      ))}
    </Box>
    </>
  );
}
